<template>
  <div class="invoice-progress-page">
    <navigation>发票进度</navigation>

    <div class="page-content" v-if="!loading">
      <!-- 借据列表 -->
      <div class="iou-list" v-if="list.length">
        <div class="iou-card" v-for="item in list" :key="item.applyNo" @click="goDetail(item.applyNo)">
          <div class="card-header">
            <span class="contract-no">{{ item.billNo }}</span>
            <span class="status-tag" :class="statusClass(item.status)">{{ item.statusText }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">资方全称</span>
            <span class="field-value">{{ item.fundName }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">本金 (元)</span>
            <span class="field-value">{{ item.principal }}</span>
          </div>
          <div class="card-divider"></div>
          <div class="card-field">
            <span class="field-label">实还利息 (元)</span>
            <span class="field-value">{{ item.paidInterest }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">实还罚息 (元)</span>
            <span class="field-value">{{ item.paidPenalty }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">实还服务费 (元)</span>
            <span class="field-value">{{ item.paidServiceFee }}</span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-else>
        <img class="empty-img" src="../quan/images/quan_empty.png" alt="暂无数据">
        <p class="empty-text">暂无数据</p>
        <p class="empty-hotline">详询客服热线：<a href="tel:4000100008">4000100008</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InvoiceProgress',

  data () {
    return {
      loading: true,
      list: []
    }
  },

  created () {
    this.fetchList()
    this.$bus.$emit('ready')
  },

  methods: {
    ...mapActions('invoice', ['getInvoiceProgressListX']),

    async fetchList () {
      try {
        const res = await this.getInvoiceProgressListX()
        if (res.code === '000000' && res.data) {
          const loanList = res.data.loanList || []
          this.list = loanList.map(item => ({
            applyNo: item.applyNo,
            billNo: item.billNo,
            fundName: item.fundName,
            principal: this.formatAmount(item.paidPrin),
            paidInterest: this.formatAmount(item.paidInt),
            paidPenalty: this.formatAmount(item.paidPen),
            paidServiceFee: this.formatAmount(item.paidServFee),
            status: item.status,
            statusText: this.statusText(item.status),
            applyTime: item.applyTime
          }))
        }
      } catch (e) {
        console.error('获取发票进度失败', e)
      } finally {
        this.loading = false
        this.$bus.$emit('ready')
      }
    },

    formatAmount (val) {
      if (val == null) return '0.00'
      return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    statusText (status) {
      const map = { ING: '开票中', SUCCESS: '开票成功', FAILED: '开票失败' }
      return map[status] || ''
    },

    statusClass (status) {
      const map = { ING: 'processing', SUCCESS: 'completed', FAILED: 'failed' }
      return map[status] || ''
    },

    goDetail (applyNo) {
      this.$router.push({ name: 'invoiceDetail', query: { applyNo } })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.invoice-progress-page {
  min-height: 100vh;
  background-color: #F7F7F7;
}

.page-content {
  padding: 20px 24px;
}

/* 借据卡片 */
.iou-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 28px 24px;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .contract-no {
    font-size: 28px;
    color: #333333;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}

/* 状态标签 */
.status-tag {
  flex-shrink: 0;
  font-size: 22px;
  padding: 4px 16px;
  border-radius: 20px;
  font-family: PingFangSC-Regular, PingFang SC;

  &.processing {
    color: #FF9F18;
    background: #FFF8F0;
  }

  &.completed {
    color: #52C41A;
    background: #F0FFF4;
  }

  &.failed {
    color: #FF4D4F;
    background: #FFF2F0;
  }
}

.card-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;

  .field-label {
    font-size: 26px;
    color: #999999;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .field-value {
    font-size: 26px;
    color: #333333;
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: right;
    word-break: break-all;
    max-width: 60%;
  }
}

.card-divider {
  height: 1px;
  background: #F0F0F0;
  margin: 12px 0;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background-color: #FFFFFF;
  border-radius: 20px;
}

.empty-img {
  width: 205px;
  height: 173px;
  margin-bottom: 32px;
}

.empty-text {
  font-size: 28px;
  color: #999999;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-bottom: 16px;
}

.empty-hotline {
  font-size: 24px;
  color: #666666;
  font-family: PingFangSC-Regular, PingFang SC;

  a {
    color: #FF9F18;
    font-weight: 500;
    text-decoration: none;
  }
}
</style>
